<div class="modal-header">
    <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close" (click)="cancel()"><span aria-hidden="true">&times;</span></button>
    <h4 class="modal-title">Upload Documents</h4>
</div>
<div class="modal-body">
    <validation-results [validationResults]="validationResults" *ngIf="showValidationComponent"></validation-results>
    <document-image [(documentsSaved)]="documentsSaved" [documentItemKeyCollection]="documentItemKeyCollection" [customerNumberId]="customerNumberId" (onClose)="cancel()" (onError)="handleValidationResult($event)" *ngIf="dataLoaded"></document-image>
</div>
